
export enum OrderStatus {
  NOVO = 'novo',
  ACEITO = 'aceito',
  PREPARO = 'preparo',
  ENTREGA = 'entrega',
  CONCLUIDO = 'concluido',
  CANCELADO = 'cancelado'
}

export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  STAFF = 'STAFF',
  KITCHEN = 'KITCHEN',
  DELIVERY = 'DELIVERY'
}

export interface UnidadeMedida {
  id: string;
  nome: string;
  sigla: string;
}

export interface Insumo {
  id: string;
  empresa_id: string;
  nome: string;
  unidade_medida_id: string;
  unidade_medida?: UnidadeMedida;
  custo_unitario: number;
  estoque_atual: number;
  estoque_minimo: number;
  created_at: string;
}

export interface FichaTecnica {
  id: string;
  produto_id: string;
  rendimento: number;
  tempo_preparo_minutos: number;
  perda_percentual: number;
  observacoes?: string;
  custo_total: number;
  cmv_total: number;
  created_at: string;
  updated_at: string;
  itens?: FichaTecnicaItem[];
}

export interface FichaTecnicaItem {
  id: string;
  ficha_tecnica_id: string;
  insumo_id: string;
  insumo?: Insumo;
  quantidade: number;
  custo_momento: number;
}

export interface MovimentacaoEstoque {
  id: string;
  empresa_id: string;
  insumo_id: string;
  tipo: 'entrada' | 'saida' | 'ajuste' | 'venda';
  quantidade: number;
  motivo?: string;
  created_at: string;
  usuario_id: string;
}

export interface Fornecedor {
  id: string;
  empresa_id: string;
  nome: string;
  contato?: string;
  email?: string;
  telefone?: string;
}

export interface CompraInsumo {
  id: string;
  empresa_id: string;
  fornecedor_id: string;
  total: number;
  data_compra: string;
  created_at: string;
}

export interface ClientePerfil {
  id: string;
  nome: string;
  whatsapp: string;
  email?: string;
}

export interface ClienteEndereco {
  id: string;
  cliente_id: string;
  titulo: string;
  endereco: string;
  bairro_id: string;
  ponto_referencia?: string;
}

export interface Empresa {
  id: string;
  nome: string;
  slug: string;
  descricao?: string;
  horarios?: string;
  telefone_whatsapp: string;
  plano: string; 
  status: 'ativo' | 'suspenso';
  created_at: string;
  logo_url?: string;
  cor_primaria?: string;
  permite_relatorios?: boolean;
  permite_dashboard_avancado?: boolean;
}

export interface Categoria {
  id: string;
  empresa_id: string;
  nome: string;
  ordem: number;
  ativo: boolean;
}

export interface AdicionalCategoria {
  id: string;
  empresa_id: string;
  nome: string;
  minimo: number;
  maximo: number;
  obrigatorio: boolean;
  ativo: boolean;
  itens?: AdicionalItem[];
}

export interface AdicionalItem {
  id: string;
  categoria_adicional_id: string;
  nome: string;
  preco: number;
  ativo: boolean;
}

export interface Bairro {
  id: string;
  empresa_id: string;
  nome: string;
  taxa: number;
}

export interface UserProfile {
  id: string;
  user_id: string;
  empresa_id: string | null;
  role: UserRole;
  ativo: boolean;
  metadata?: any;
  empresas?: Empresa | null;
}

export interface AuthUser {
  id: string;
  email?: string;
  nome?: string;
}

export interface AuthContextType {
  user: AuthUser | null;
  profile: UserProfile | null;
  empresaId: string | null;
  role: UserRole | null;
  loading: boolean;
  isAuthenticated: boolean;
  isSuperAdmin: boolean;
  signOut: () => Promise<void>;
  refreshProfile: () => Promise<void>;
}

export interface Produto {
  id: string;
  empresa_id: string;
  nome: string;
  descricao: string;
  preco: number;
  categoria: string;
  ativo: boolean;
  imagem_url?: string;
  adicionais_ids?: string[]; 
}

export interface Pedido {
  id: string;
  empresa_id: string;
  nome_cliente: string;
  whatsapp_cliente: string;
  endereco: string;
  total: number;
  status: OrderStatus;
  created_at: string;
  observacoes?: string;
  forma_pagamento?: string;
  taxa_entrega?: number;
  bairro_nome?: string;
}

export interface ItemPedido {
  id: string;
  pedido_id: string;
  produto_id: string;
  quantidade: number;
  preco_unitario: number;
  produto_nome?: string;
  observacao?: string;
}

export interface CartItem extends Produto {
  quantidade: number;
  observacao?: string;
  adicionais_selecionados?: AdicionalItem[];
}
